import { useMemo, useState } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Button, message, Popconfirm, Popover } from 'antd';
import { isInternalTech } from '../../utils/AuthUtils';
import * as React from 'react';
import { ROLE_TYPES } from '../../utils/DataConstants';
import { DeleteOutlined, InfoCircleFilled } from '@ant-design/icons';
import QuoteUploader from '../quote_uploader/QuoteUploader';
import { QUOTE_STATUSES } from '../../constants/QuoteStatuses';
import { BUYER_ADMIN_ONLY } from '../roles/roles';

const QuoteUploadButton = ({
	currentUser,
	handleQuotePDFUploadChange,
	quote,
	generatingPDF,
	deletingPDF,
	generateQuotePDF,
	userType,
	isDisplayOnly = false,
}) => {
	const isBuyerOrInternalTech = useMemo(
		() => userType === ROLE_TYPES.BUYER || isInternalTech(currentUser),
		[userType, currentUser]
	);
	const hasPDF = useMemo(() => quote.proposalPdfLink && quote.proposalPdfLink.length > 0, [quote]);

	const pdfElement = useMemo(
		() =>
			hasPDF ? (
				<p className="mb-0">
					<a href={quote.proposalPdfLink} target="_blank" rel="noreferrer">
						Quote PDF
					</a>
				</p>
			) : null,
		[hasPDF, quote.proposalPdfLink]
	);

	const deletePdf = useMemo(
		() =>
			!isBuyerOrInternalTech && hasPDF && [QUOTE_STATUSES.draft].includes(quote.status) ? (
				<Button
					title="Delete"
					type="link"
					className="ml-2"
					loading={deletingPDF}
					icon={<DeleteOutlined style={{ marginBottom: -4 }} />}
					onClick={() => {
						message.success('Updating Quote');
						handleQuotePDFUploadChange(quote)(null);
					}}
				/>
			) : null,
		[handleQuotePDFUploadChange, quote, hasPDF, isBuyerOrInternalTech]
	);

	const uploadButton = useMemo(() => {
		const userIsBuyerAdminOrManager = currentUser.roles.some((role) => BUYER_ADMIN_ONLY.has(role));
		const quoteUploader = (
			<QuoteUploader
				roleType={userType}
				quoteId={quote && quote.id}
				quote={quote}
				defaultFileList={[]}
				multiple={false}
				handleUploadSuccess={handleQuotePDFUploadChange(quote)}
			/>
		);
		switch (quote.status) {
			case QUOTE_STATUSES.draft:
				if (userType === ROLE_TYPES.BUYER) {
					if (userIsBuyerAdminOrManager) {
						return quoteUploader;
					}
				} else {
					return quoteUploader;
				}
				return null;
			case QUOTE_STATUSES.pending:
				if (userType === ROLE_TYPES.BUYER) {
					if (userIsBuyerAdminOrManager) {
						return quoteUploader;
					}
				}
				return null;
			case QUOTE_STATUSES.disputed:
				//Anyone can upload
				return quoteUploader;
		}
	}, [userType, quote, handleQuotePDFUploadChange, isBuyerOrInternalTech]);

	const uploadQuote = [
		...(isBuyerOrInternalTech ? [QUOTE_STATUSES.pending] : []),
		QUOTE_STATUSES.draft,
	].some((status) => status === quote.status);

	const generateQuote = !hasPDF ? (
		<p style={{ marginBottom: 0, marginTop: 0 }}>
			Need a quote PDF?{' '}
			<Button
				loading={generatingPDF}
				type="link"
				onClick={() => generateQuotePDF(quote.id)}
				style={{ marginBottom: 0, marginTop: 0 }}
			>
				Generate PDF
			</Button>
		</p>
	) : null;

	return pdfElement || uploadQuote ? (
		<div>
			<div className="mb-1 flex flex-row items-end">
				{pdfElement} {!isDisplayOnly && deletePdf}
			</div>
			{!isDisplayOnly && uploadButton}
			{!isDisplayOnly && generateQuote}
		</div>
	) : !isDisplayOnly && isBuyerOrInternalTech ? (
		<div>{generateQuote}</div>
	) : null;
};
const mapStateToProps = (state, ownProps) => ({
	currentUser: state.session.currentUser,
});
const mapDispatchToProps = (dispatch) => ({});

const ComponentWithoutUserType = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(QuoteUploadButton)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
